module.exports = __webpack_public_path__ + "static/img/penny_pictgrid19_920x854.a7ba718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid19_920x854.jpg
// module id = KrCB
// module chunks = 0